import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Analytics from '../components/MT_Score/Analytics'

const MtScoreAnalytics = () => {
  return (
    <>
    <Navbar />
    <Analytics />
    </>
  )
}

export default MtScoreAnalytics